import Agencies from "./agencies";
import ProfileCard from "./profileCard";
import SchoolMgt from "./schoolMgt";
import Settings from "./settings";
import ModulesList from "./settings/modulesList";
import RoleList from "./settings/roleList";
import UserLogins from "./settings/userLogins";
import WelcomePage from "./WelcomePage";
import ResellerSetup from "./agencies/resellerSetup.jsx";
export default [
  {
    path: "/",
    element: WelcomePage,
    title: "Dashboard",
    module: "any",
    action: "any",
    exact: true,
  },
  {
    path: "/profile-card",
    element: ProfileCard,
    title: "Profile",
    module: "my_profile",
    action: "action_list",
    exact: true,
  },
  {
    path: "/settings",
    element: Settings,
    title: "Settings",
    module: [
      "user_roles",
      "payment_gateways",
      "user_logins",
      "agent_mgt",
      "user_permissions",
    ],
    action: "action_list",
    exact: true,
  },
  {
    path: "/settings/modules",
    element: ModulesList,
    title: "Settings",
    module: "modules",
    action: "action_list",
    exact: true,
  },

  {
    path: "/settings/roles",
    element: RoleList,
    title: "Settings",
    module: "user_roles",
    action: "action_list",
    exact: true,
  },
  {
    path: "/settings/user-logins",
    element: UserLogins,
    title: "User Logins",
    module: "user_logins",
    action: "action_list",
    exact: true,
  },
  {
    path: "/agents",
    element: Agencies,
    title: "Agencies",
    module: "agent_mgt",
    action: "action_list",
    exact: true,
  },
  {
    path: "/schools",
    element: SchoolMgt,
    title: "Agencies",
    module: "school_mgt",
    action: "action_list",
    exact: true,
  },
  {
    path: "/reseller-setup",
    element: ResellerSetup,
    title: "Reseller",
    module: "reseller_setup",
    action: "action_list",
    exact: true,
  },
];
